export default class HeaderScrollScale {
  init() {
    const $els = document.querySelectorAll('[data-header-scroll-scale]');

    if ($els.length < 1) {
      return this;
    }

    [...$els].forEach(($el) => {
      const $image = $el.querySelector('.image');

      this.setTransform($image);

      window.addEventListener('scroll', () => {
        this.setTransform($image);
      }, false);
    });

    return this;
  }

  setTransform($el) {
    if (window.scrollY >= 1) {
      const $element = $el;
      const scrolled = window.scrollY / 1000 + 1;
      const transformValue = `scale(${scrolled})`;

      $element.style.transform = transformValue;
    }

    return this;
  }
}
